/* eslint-disable no-unused-vars,no-console */
import { AUTH } from '../../store/types';

import auth from './auth';

export default {
    [AUTH.REQUEST] (context, user) {
        context.commit(AUTH.REQUEST);

        return auth.authenticate(user).then((token) => {
            context.commit(AUTH.SUCCESS, token);
        }).catch((err) => {
            context.commit(AUTH.ERROR, err.error);
            throw err;
        });
    },
    [AUTH.CURRENT_USER] (context) {
        return auth.currentUser()
            .then((resp) => {
                context.commit(AUTH.CURRENT_USER, resp.user);
                return resp.user;
            });
    },
    [AUTH.INVALID_CREDENTIALS] (context) {
        context.commit(AUTH.INVALID_CREDENTIALS);
        return { redirectTo: '/login' };
    },
    [AUTH.TOKEN_REFRESH] (context, newToken) {
        context.commit(AUTH.SUCCESS, newToken);
    },
    [AUTH.TOKEN_REQUEST_NEW] (context) {
        return auth.requestNewToken()
            .then((token) => {
                context.commit(AUTH.SUCCESS, token);
            });
    },
    [AUTH.TOKEN_EXPIRED] (context) {
        context.commit(AUTH.TOKEN_EXPIRED);
        context.commit(AUTH.CLEAR);
        return { redirectTo: '/login' };
    },
    [AUTH.TOKEN_INVALID] (context) {
        context.commit(AUTH.TOKEN_INVALID);
        context.commit(AUTH.CLEAR);
        return { redirectTo: '/login' };
    },
    [AUTH.LOGOUT] (context) {
        return auth.logout()
            .then(() => {
                context.commit(AUTH.LOGOUT);
                context.commit(AUTH.CLEAR);
                return { redirectTo: '/login' };
            })
            .catch(() => ({ redirectTo: '/login' }));
    },
    [AUTH.CLEAR] (context) {
        context.commit(AUTH.CLEAR);
    },
};



// WEBPACK FOOTER //
// ./src/modules/auth/actions.js